module.exports = __webpack_public_path__ + "img/slices.3b4a5fdd.png";